import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'
import App from './App'
import './styles.css'

const posthogKey =
  import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN ||
  import.meta.env.VITE_PUBLIC_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST

if (posthogKey && typeof posthogKey === 'string' && posthogKey.length > 0) {
  posthog.init(posthogKey, {
    api_host: posthogHost || 'https://rproxy.tinkernlabs.com',
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>
)


